import { combineReducers } from 'redux';
import { i18nReducer } from 'react-redux-i18n';
import spreadsheetFormat from './spreadsheetFormat';

const reducers = combineReducers({
	spreadsheetFormat,
	i18n: i18nReducer
});
export default reducers;